/* istanbul ignore file */

export { ContactCard as default } from "./ContactCard";
